import { setCartState } from './state';
import * as mutations from './mutations';
import * as actions from './actions';
import getters from './getters';

export default (headerCartButton) => ({
  state: setCartState(headerCartButton),
  mutations,
  actions,
  getters,
  namespaced: true,
});
